// extracted by mini-css-extract-plugin
export default {"contact":"contact_contact__ND+re","title":"contact_title__uZ4HE"};